// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { useIncomingPayment, getSafeCustomerName } from '@tectonics/prs/incoming-payment';
import { translate } from '@tectonics/translate';

export function Greeting(): Node {
  const incomingPayment = useIncomingPayment();
  const customerName = getSafeCustomerName(incomingPayment).toLowerCase();

  return (
    <Root>
      {translate('shopify.greeting', {customerName})}
    </Root>
  );
}

const Root = styled.div`
  font-family: ${props => props.theme.fontFamily.display};
  font-size: 1.6rem;
  font-weight: 400;
  color: rgb(35, 151, 212);
  text-transform: capitalize;
`;
